<app-dialog-base [Title]='"Objects"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="navblock">
    <button class="btn_graygray" [disabled]="selectObjectsCount == 0" (click)="resyncKeys()">{{'Resync'|translate}}</button>
    <input type="text" class="searchinput" placeholder="{{'Find by name' | translate }}"  [(ngModel)]="nameFilter"
           (input)="onTermChange($event)"/>
  </div>
  <div class="tablewrap resizetable">
    <div class="table">
      <table fixedcols="[0,2,3]">
        <tr>
          <th>
            <switch-all-checkbox [items]="objects | groupFilter : filter" />
          </th>
          <th>{{'Name'|translate}}</th>
          <th>{{'Status'|translate}}</th>
          <th>
            <button class="btn_img btn_graygray btn_plusorange" style="padding: 6px;" (click)="selectKeys()"></button>
          </th>
        </tr>
        <tr *ngFor="let key of keys | groupFilter : filter">
          <td>
            <input type="checkbox" [(ngModel)]="key.IsChecked" (change)="onToggle(key)"/>
          </td>
          <td>{{key.ObjectName}}</td>
          <td class="green" *ngIf="key.isSynced()">{{'Synced'|translate}}</td>
          <td class="red" *ngIf="!key.isSynced() && !key.isDeleteRequired()">{{'Synchronization required'|translate}}</td>
          <td class="red" *ngIf="key.isDeleteRequired()">{{'Waiting to be removed'|translate}}</td>
          <td>
            <button class="btn_img btn_edit" title="{{'Edit'|translate}}"  (click)="openEditKeyDialog(key)"></button>
            <button class="btn_img btn_trush" title="{{'Delete'|translate}}" (click)="deleteKeyFromSync(key)"></button>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <div leftFooterColumn>
    <button class="btndel" (click)="deleteSelected()">{{'Delete selected'|translate}} (<span>{{selectObjectsCount}}</span>)</button>
  </div>
</app-dialog-base>
<template #objectsListDialog></template>
<template #mgmtDialog></template>
